export enum DATATYPE {
  FILE = "file",
  NUMBER = "number",
  SUBMIT = "submit",
  PASS = "password",
  TEXT = "text",
}
